import React, { createContext, useContext, useEffect, useState } from 'react';

export type Theme = 'red' | 'blue' | 'green' | 'black';
type settings = {
	logo: string;
	rotation?: 0 | 90 | 180 | 270;
};
interface ThemeContextProps {
	theme: Theme | null;
	updateTheme: (theme: Theme | null) => void;
	settings: settings;
	setSettings: React.Dispatch<React.SetStateAction<settings>>;
}
const ThemeContext = createContext<ThemeContextProps>({} as ThemeContextProps);

export const ThemeProvider: React.FC<{ children: React.ReactNode }> = ({
	children,
}) => {
	const [theme, setTheme] = useState<Theme | null>(null);
	const [settings, setSettings] = useState<settings>({
		logo: '',
	});

	useEffect(() => {
		const body = document.body;
		body.classList.remove(
			'theme-red',
			'theme-blue',
			'theme-green',
			'theme-black',
		);
		if (theme) body.classList.add(`theme-${theme}`);
	}, [theme]);

	function updateTheme(theme: Theme | null) {
		setTheme(theme ? (theme.toLocaleLowerCase() as Theme) : null);
	}

	return (
		<ThemeContext.Provider
			value={{ theme, updateTheme, settings, setSettings }}
		>
			{children}
		</ThemeContext.Provider>
	);
};

export const useTheme = () => useContext(ThemeContext);
